export const name = '$gzHpId';
export const HPID_TYPE = {
  LOGIN: 'login',
  LOGOUT: 'logout',
};

export default function $gzHpId(
  rnHttp,
  rnLocale,
  $window,
  $state
) {
  'ngInject';

  // Dynamic parameters are those not explicitly set in the router URL.
  // Instead these are defined in the params object, usually embedded in a "data" object param.
  const DYNAMIC_PARAMS = ['locale', 'target'];
  // Default parameters to set for the target URL.
  // Currently, these are parameters we want to ensure are cleared
  // since AAA will set these on a failure.
  const DEFAULT_TARGET_PARAMS = {
    statusCode: null,
    subCode: null,
    username: null,
    altUsername: null,
  };

  let service = {
    getLink,
    redirect,
    createTargetUrl,
  };
  return service;

  function getAllLinks(linkType, redirectUrl, data = {}) {
    return rnLocale.getBestFit().then(locale => {
      let body = _.assign({
        linkType,
        fragmentParams: true,
      }, data);

      // Allow for a locale override
      if (data.locale) {
        locale = data.locale;
      }

      body.locale = getHpIdLocale(locale);
      if (redirectUrl) {
        // Ensure PrintOS locale is returned to be set correctly in preferences.
        body.redirectUrl = ensureDynamicParams(redirectUrl, { locale: locale.value });
      }

      return rnHttp.post('aaa', 'hpid/link', body).then(resp => {
        return resp.data;
      });
    });
  }

  function getLink(linkType = HPID_TYPE.LOGIN, redirectUrl = $window.location.href, data = undefined) {
    return getAllLinks(linkType, redirectUrl, data)
      .then(data => {
        return data.loginLink;
      });
  }

  function getCreateLink(linkType = HPID_TYPE.LOGIN, redirectUrl = $window.location.href, data = undefined) {
    return getAllLinks(linkType, redirectUrl, data)
      .then(data => {
        return data.createLink;
      });
  }

  function redirect(type, redirectUrl, data, createAccount = false) {
    // Required to ensure Firefox BFCache (back-forward cache) doesn't cache the page in a spinning state.
    // Without this, sign in followed by clicking back results in a stuck sign-in page with a spinner.
    // See https://coderwall.com/p/3t6ila/disable-the-back-forward-cache-of-firefox-and-safari
    $window.addEventListener('unload', () => {});

    if (!redirectUrl) {
      redirectUrl = createTargetUrl();
    }

    if (createAccount) {
      return getCreateLink(type, redirectUrl, data, createAccount).then(link => {
        $window.location.href = link;
      });
    } else {
      return getLink(type, redirectUrl, data).then(link => {
        $window.location.href = link;
      });
    }
  }

  function createTargetUrl(uiState = $state.current.name, params = {}) {
    params = Object.assign({}, DEFAULT_TARGET_PARAMS, params);
    let uiRouterParams = _.omit(params, DYNAMIC_PARAMS);
    let targetUrl = $window.location.origin + $window.location.pathname + $state.href(uiState, uiRouterParams);
    targetUrl = ensureDynamicParams(targetUrl, params);
    return targetUrl;
  }

  function ensureDynamicParams(url = '', params = {}) {
    // split out URL components
    let [baseUrl, fragment] = url.split('#');

    if (fragment === undefined) {
      fragment = '';
    }

    let [route, routeParams] = fragment.split('?');
    if (routeParams === undefined) {
      routeParams = '';
    }

    _.forEach(DYNAMIC_PARAMS, dynamicParam => {
      let dynamicParamValue = params[dynamicParam];
      if (dynamicParamValue) {
        if (dynamicParam === 'target') {
          dynamicParamValue = $window.encodeURIComponent(dynamicParamValue);
        }

        // append params
        if (routeParams) {
          routeParams += '&';
        }
        routeParams += `${dynamicParam}=${dynamicParamValue}`;
      }
    });

    // reconstitute url
    return `${baseUrl}#${route}${routeParams ? '?' : ''}${routeParams}`;
  }

  function getHpIdLocale(printOsLocale) {
    let hpIdLocale = printOsLocale.value;
    if (printOsLocale.value === 'zh-HANS') {
      hpIdLocale = 'zh-CN';
    } else if(printOsLocale.value === 'ko-KO') {
      hpIdLocale = 'ko-KR';
    }
    return hpIdLocale;
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/hpid/hpid.service.js